import { Badge } from "./ui/badge";
import { STATUS_STYLES } from "../lib/helpers";
import { useT } from "../lib/i18n";

export function PageHeader({ eyebrow, title, children }) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-8 fade-up">
      <div>
        {eyebrow && <p className="text-xs font-semibold tracking-[0.18em] uppercase text-muted-foreground mb-2">{eyebrow}</p>}
        <h1 className="text-3xl sm:text-4xl font-bold text-foreground" data-testid="page-title">{title}</h1>
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function StatusBadge({ status, testId }) {
  const { t } = useT();
  return (
    <Badge variant="outline" data-testid={testId} className={`rounded-full font-medium ${STATUS_STYLES[status] || ""}`}>
      {t(`status_${status}`)}
    </Badge>
  );
}

export function Empty({ text, testId }) {
  return (
    <div data-testid={testId} className="rounded-[var(--radius)] border border-dashed p-10 text-center text-sm text-muted-foreground">
      {text}
    </div>
  );
}

export function Field({ label, children, className = "" }) {
  return (
    <label className={`flex flex-col gap-1.5 ${className}`}>
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

export function NativeSelect({ value, onChange, options, testId, className = "" }) {
  return (
    <select
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`h-10 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring ${className}`}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}

export function PlainSelect({ className = "", children, ...props }) {
  return (
    <select {...props} className={`h-10 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring ${className}`}>
      {children}
    </select>
  );
}


export function StatCard({ label, value, icon: Icon, testId, tone = "" }) {
  return (
    <div data-testid={testId} className={`lift relative overflow-hidden rounded-[var(--radius)] border bg-card p-6 ${tone}`}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-primary" />}
      </div>
      <div className="mt-4 font-display text-2xl sm:text-3xl font-bold">{value}</div>
    </div>
  );
}
